import { Component } from "react";
import emailjs from '@emailjs/browser';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Recaptcha from 'react-recaptcha'
import "./Construcciones.css";

/* ─────────────────────────────────────────────
   SVG ICONS
───────────────────────────────────────────── */
const IconWrench  = () => <svg viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>;
const IconBolt    = () => <svg viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IconShield  = () => <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
const IconSun     = () => <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="2"/><path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>;
const IconHome    = () => <svg viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IconMonitor = () => <svg viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/></svg>;
const IconCheck   = () => <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>;
const IconMapPin  = () => <svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const IconPhone   = () => <svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.5 10.81 19.79 19.79 0 011.5 2.18 2 2 0 013.5.07h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L7.91 7a16 16 0 006.86 6.86l.93-.93a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>;

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const MARQUEE_ITEMS = [
  "FERRETERÍA INDUSTRIAL", "MATERIALES ELÉCTRICOS", "HERRAMIENTAS PROFESIONALES",
  "PLOMERÍA Y TUBERÍA", "PINTURAS Y ACABADOS", "FIJACIONES Y ANCLAJES", "CONSTRUCCIÓN Y OBRA",
];

const CATEGORIES = [
  { Icon: IconWrench,  title: "HERRAMIENTAS",          desc: "Taladros, amoladoras, sierras circulares, llaves, destornilladores y equipos de medición.",   count: "+800 referencias"   },
  { Icon: IconBolt,    title: "MATERIALES ELÉCTRICOS",  desc: "Cable eléctrico, canaleta, cajas de paso, breakers, tomas, interruptores y luminarias LED.",  count: "+1,200 referencias" },
  { Icon: IconShield,  title: "FIJACIONES Y ANCLAJES",  desc: "Tornillos, pernos, tuercas, remaches, anclajes químicos, tarugos y soportería estructural.",  count: "+2,000 referencias" },
  { Icon: IconSun,     title: "PLOMERÍA Y TUBERÍA",     desc: "Tubería PVC, CPVC, HG, llaves de paso, codos, tees, válvulas y bombas de agua.",              count: "+600 referencias"   },
  { Icon: IconMonitor, title: "PINTURAS Y ACABADOS",    desc: "Pinturas de agua, aceite, esmaltes, barnices, selladores e impermeabilizantes.",               count: "+300 referencias"   },
  { Icon: IconHome,    title: "CONSTRUCCIÓN GENERAL",   desc: "Cemento, block, varilla, malla, lámina, techos, aditivos y equipos de seguridad industrial.",  count: "+400 referencias"   },
];

const WHY_ITEMS = [
  { title: "Asesoría técnica especializada",              desc: "Nuestro equipo te guía para encontrar el producto correcto según tu aplicación y presupuesto."                  },
  { title: "Entrega a domicilio y proyectos",             desc: "Despachos a obra, empresa o residencia en Guatemala. Entregas planificadas para grandes volúmenes."            },
  { title: "Respaldo de Drycom International",            desc: "Como división de Drycom International, contamos con alianzas con los principales distribuidores de la región." },
];

const BRANDS = ["STANLEY", "DEWALT", "BOSCH", "3M", "AMANCO", "CEMEX", "CONDUMEX", "ABB", "SIEMENS", "TRUPER"];

const CONTACT_ITEMS = [
  { Icon: IconMapPin, title: "Ubicación",          val: "Guatemala City, Guatemala\nZona Industrial · Acceso para vehículos de carga"        },
  { Icon: IconPhone,  title: "Teléfono",           val: "+502 2201-1250\nLun – Vie: 8:00 am – 6:00 pm · Sáb: 8:00 am – 12:00 pm"            }
  ];

const FORM_CATEGORIES = [
  "Herramientas", "Materiales Eléctricos", "Plomería y Tubería",
  "Fijaciones y Anclajes", "Pinturas y Acabados", "Construcción General", "Varios / Proyecto completo",
];

  const currentDate = new Date(); // Creates a new Date object for the current time
const currentYear = currentDate.getFullYear(); // Gets the four-digit year (e.g., 2026)
/* ─────────────────────────────────────────────
   MAIN CLASS COMPONENT
───────────────────────────────────────────── */
export class Construcciones extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formSent: false,
      loading: false,
      isVerified: false, // Añade esto
  recaptchaToken: "", // Añade esto para guardar el token
      form: { name: "", company: "", phone: "", email: "", category: "", message: "" },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetForm    = this.resetForm.bind(this);
    this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
    this.verifiedRecaptcha = this.verifiedRecaptcha.bind(this);
  }

  recaptchaLoaded() {
      this.setState({ recaptchaLoad: true });
  }
  
  verifiedRecaptcha(response) {
     if (response) {
    this.setState({ 
      isVerified: true, 
      recaptchaToken: response // Guardamos el token
    });
  }
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState(prevState => ({
      form: { ...prevState.form, [name]: value }
    }));
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });

    // Configuración EmailJS
    const serviceID = 'service_c6wbtzt';
    const templateID = 'template_87pr9kp';
    const publicKey = 'user_C6smEMFMth386EZ6bxbcx';

    const templateParams = {
      from_name: this.state.form.name,
      contact_email: this.state.form.email,
      from_empresa: this.state.form.company,
      telefono: this.state.form.phone,
      category: this.state.form.category,
      message: this.state.form.message,
      'g-recaptcha-response': this.state.recaptchaToken, // CLAVE: Esto soluciona el error
    };

    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        this.setState({ formSent: true, loading: false });
      }, (err) => {
        alert('Hubo un error al enviar el mensaje.');
        this.setState({ loading: false });
      });
  }

  resetForm() {
    this.setState({
      formSent: false,
      loading: false,
      form: { name: "", company: "", phone: "", email: "", category: "", message: "" },
    });
  }

  /* ── RENDER SECTIONS ─────────────────────── */

  renderNavbar() {
    return (
      <Navbar expand="lg" className="cf-navbar fixed-top px-4 px-lg-5">
        <Navbar.Brand className="d-flex flex-column">
          <span className="cf-nav-sub">División de Drycom International</span>
          <span className="cf-nav-name">CONSTRUCCIONES <span>FUTURAS</span></span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="cf-nav-collapse" />
        <Navbar.Collapse id="cf-nav-collapse" className="justify-content-end">
          <Nav className="align-items-lg-center gap-lg-2 mt-3 mt-lg-0">
            <Nav.Link href="#categorias" className="cf-nav-link">Productos</Nav.Link>
            <Nav.Link href="#nosotros"   className="cf-nav-link">Nosotros</Nav.Link>
            <Nav.Link href="#marcas"     className="cf-nav-link">Marcas</Nav.Link>
            <Nav.Link href="/"     className="cf-nav-link">Drycom</Nav.Link>
            <a href="#contacto" className="cf-nav-cta ms-lg-2">Contáctanos</a>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }

  renderHero() {
    return (
      <section className="cf-hero bg-cf-dark">
        <Container fluid className="px-0 h-100">
          <Row className="g-0 align-items-stretch" style={{ minHeight: "100vh" }}>
            <Col lg={6} className="d-flex align-items-center">
              <div className="px-4 px-lg-5 py-5" style={{ maxWidth: 600 }}>
                <div className="cf-eyebrow">Ferretería &amp; Eléctricos · Guatemala</div>
                <h1 className="cf-hero-title">
                  TODO LO QUE<br />
                  <span className="accent">CONSTRUYES</span><br />
                  <span className="outline">NECESITAS</span>
                </h1>
                <p className="cf-hero-desc mt-4">
                  Herramientas, materiales eléctricos, tubería, pintura, fijaciones y más.
                  Construcciones Futuras es tu aliado profesional para cada proyecto, obra o instalación.
                </p>
                <div className="cf-hero-actions d-flex gap-3 mt-4 flex-wrap">
                  <Button href="#categorias" className="btn-cf-primary px-4 py-3">VER PRODUCTOS</Button>
                  <Button href="#contacto"   className="btn-cf-outline  px-4 py-3">COTIZAR AHORA</Button>
                </div>
                <div className="cf-hero-stats d-flex gap-4 mt-5">
                  {[["5K+", "Productos en stock"], ["15+", "Marcas líderes"], ["24H", "Entrega express"]].map(([num, label]) => (
                    <div key={label}>
                      <div className="cf-stat-num">{num}</div>
                      <div className="cf-stat-label">{label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
            <Col lg={6} className="cf-hero-panel">
              <div className="cf-icon-grid">
                {[
                  { Icon: IconWrench,  label: "Herramientas", highlight: true  },
                  { Icon: IconBolt,    label: "Eléctrico",    highlight: false },
                  { Icon: IconSun,     label: "Plomería",     highlight: false },
                  { Icon: IconMonitor, label: "Pintura",      highlight: false },
                ].map(({ Icon, label, highlight }) => (
                  <div key={label} className={`cf-icon-cell${highlight ? " highlight" : ""}`}>
                    <Icon /><span className="icon-label">{label}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  renderMarquee() {
    return (
      <div className="cf-marquee">
        <div className="cf-marquee-track">
          {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
            <span key={i} className="cf-marquee-item">{item}</span>
          ))}
        </div>
      </div>
    );
  }

  renderCategories() {
    return (
      <section id="categorias" className="bg-cf-dark2 py-5 px-4 px-lg-5">
        <Container fluid>
          <Row className="justify-content-between align-items-end mb-5">
            <Col lg={5}>
              <div className="cf-section-label">Nuestro catálogo</div>
              <h2 className="cf-section-title">TODO PARA<br />TU PROYECTO</h2>
            </Col>
            <Col lg={4}>
              <p style={{ color: "var(--cf-steel)", fontSize: 14, lineHeight: 1.6 }}>
                Desde materiales básicos hasta equipos especializados.
              </p>
            </Col>
          </Row>
          <Row className="g-1">
            {CATEGORIES.map(({ Icon, title, desc, count }) => (
              <Col key={title} xs={12} md={6} lg={4}>
                <div className="cf-cat-card">
                  <div className="cf-cat-icon"><Icon /></div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                  <div className="cf-cat-count">{count}</div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    );
  }

  renderWhyUs() {
    return (
      <section id="nosotros" className="bg-cf-dark py-5 px-4 px-lg-5">
        <Container fluid>
          <Row className="g-5 align-items-center py-4">
            <Col lg={6}>
              <div className="cf-section-label">¿Por qué nosotros?</div>
              <h2 className="cf-section-title mb-4">CALIDAD QUE<br />CONSTRUYE</h2>
              <div className="d-flex flex-column gap-4">
                {WHY_ITEMS.map(({ title, desc }) => (
                  <div key={title} className="d-flex gap-3 cf-why-item">
                    <div className="cf-check"><IconCheck /></div>
                    <div><h4>{title}</h4><p>{desc}</p></div>
                  </div>
                ))}
              </div>
            </Col>
            <Col lg={6}>
              <div className="position-relative">
                <div className="cf-why-bignum">CF</div>
                <div className="cf-why-box">
                  <div className="cf-quote-mark">"</div>
                  <p>
                    Nuestra misión es proveer los materiales, herramientas y soluciones que cada profesional
                    y constructor necesita para llevar sus proyectos al siguiente nivel — con el mejor precio,
                    disponibilidad y servicio del mercado guatemalteco.
                  </p>
                  <div className="d-flex align-items-center gap-3 mt-4 pt-3"
                    style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
                    <div style={{ width: 36, height: 36, background: "var(--cf-orange)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Bebas Neue'", fontSize: 18, color: "white", flexShrink: 0 }}>CF</div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14, color: "var(--cf-white)" }}>Construcciones Futuras</div>
                      <div style={{ fontSize: 11, color: "var(--cf-steel)" }}>División de Drycom International</div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  renderBrands() {
    return (
      <section id="marcas" className="bg-cf-dark2 py-5 px-4 px-lg-5 text-center">
        <p style={{ fontSize: 11, letterSpacing: 4, textTransform: "uppercase", color: "rgba(184,184,184,0.5)", marginBottom: 36 }}>
          Marcas que distribuimos
        </p>
        <div className="d-flex flex-wrap gap-2 justify-content-center">
          {BRANDS.map(b => <div key={b} className="cf-brand-pill">{b}</div>)}
        </div>
      </section>
    );
  }

  renderCTABanner() {
    return (
      <div className="cf-cta-banner py-5 px-4 px-lg-5">
        <Container fluid>
          <Row className="align-items-center g-4 py-3">
            <Col lg={8}>
              <h2 className="cf-cta-title">¿LISTO PARA<br />TU PRÓXIMO<br />PROYECTO?</h2>
              <p className="cf-cta-desc">
                Solicita tu cotización ahora. Atendemos a contratistas, empresas constructoras,
                electricistas y público en general.
              </p>
            </Col>
            <Col lg={4} className="d-flex justify-content-lg-end">
              <Button href="#contacto" className="btn-cf-white px-4 py-3">SOLICITAR COTIZACIÓN →</Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  renderContact() {
    const { formSent, form, loading } = this.state;
    return (
      <section id="contacto" className="bg-cf-dark py-5 px-4 px-lg-5">
        <Container fluid>
          <Row className="g-5 py-4">
            {/* Info */}
            <Col lg={5}>
              <div className="cf-section-label">Estamos aquí para ayudarte</div>
              <h2 className="cf-section-title mb-4">contáctenos</h2>
              <div className="d-flex flex-column gap-4">
                {CONTACT_ITEMS.map(({ Icon, title, val }) => (
                  <div key={title} className="d-flex gap-3">
                    <div className="cf-contact-icon"><Icon /></div>
                    <div>
                      <div className="cf-contact-label">{title}</div>
                      <p className="cf-contact-val" style={{ whiteSpace: "pre-line" }}>{val}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>

            {/* Form */}
            <Col lg={7}>
              {formSent ? (
                <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center py-5">
                  <div style={{ width: 64, height: 64, background: "var(--cf-orange)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                    <svg viewBox="0 0 24 24" style={{ width: 28, height: 28, stroke: "white", fill: "none", strokeWidth: 2.5 }}>
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <h3 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 40, color: "var(--cf-white)" }}>
                    ¡SOLICITUD ENVIADA!
                  </h3>
                  <p style={{ color: "var(--cf-steel)", fontSize: 15, maxWidth: 360 }}>
                    Nos pondremos en contacto contigo en las próximas horas.
                  </p>
                  <Button className="btn-cf-primary px-4 py-2 mt-4" onClick={this.resetForm}>
                    ENVIAR OTRA SOLICITUD
                  </Button>
                </div>
              ) : (
                <Form onSubmit={this.handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <label className="cf-form-label">Nombre</label>
                      <Form.Control name="name" type="text" className="cf-input" value={form.name} onChange={this.handleChange} required />
                    </Col>
                    <Col md={6}>
                      <label className="cf-form-label">Empresa</label>
                      <Form.Control name="company" type="text" className="cf-input" value={form.company} onChange={this.handleChange} />
                    </Col>
                    <Col md={6}>
                      <label className="cf-form-label">Teléfono</label>
                      <Form.Control name="phone" type="tel" className="cf-input" value={form.phone} onChange={this.handleChange} />
                    </Col>
                    <Col md={6}>
                      <label className="cf-form-label">Correo electrónico</label>
                      <Form.Control name="email" type="email" className="cf-input" value={form.email} onChange={this.handleChange} required />
                    </Col>
                    <Col xs={12}>
                      <label className="cf-form-label">Categoría de interés</label>
                      <select name="category" className="cf-input" value={form.category} onChange={this.handleChange} required>
                        <option value="" disabled>Seleccionar categoría</option>
                        {FORM_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </Col>
                    <Col xs={12}>
                      <label className="cf-form-label">Mensaje / descripción del proyecto</label>
                      <Form.Control as="textarea" name="message" className="cf-input" rows={5} value={form.message} onChange={this.handleChange} required />
                    </Col>
                    <Col xs={12}>
                        <Recaptcha
                        sitekey="6LeD59MaAAAAAIWNbk6B_MT-IDf6P0GbgwURUXAB"
                        render="explicit"
                        onloadCallback={this.recaptchaLoaded}
                        verifyCallback={this.verifiedRecaptcha}
                        theme="dark"
                        /> 
                    </Col>
                    <Col xs={12}>
                      <Button 
                        type="submit" 
                        className="btn-cf-primary w-100 py-3" 
                        disabled={loading}
                      >
                        {loading ? 'ENVIANDO...' : 'ENVIAR SOLICITUD'}
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    
                </Row>
                </Form>
                
              )}
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  renderFooter() {
    return (
      <footer className="cf-footer px-4 px-lg-5 pt-5 pb-3">
        <Container fluid>
          <Row className="g-4 mb-4">
            <Col lg={4}>
              <div className="cf-footer-name">CONSTRUCCIONES <span>FUTURAS</span></div>
              <div className="cf-footer-tagline">Ferretería · Eléctricos · Construcción</div>
              <div className="cf-footer-division">Una división de Drycom International</div>
            </Col>
            <Col xs={6} lg={2}>
              <div className="cf-footer-heading">Productos</div>
              {["Herramientas", "Materiales Eléctricos", "Plomería y Tubería", "Pinturas", "Fijaciones"].map(l => (
                <a key={l} href="#categorias" className="cf-footer-link">{l}</a>
              ))}
            </Col>
            <Col xs={6} lg={2}>
              <div className="cf-footer-heading">Empresa</div>
              {["Sobre nosotros", "Drycom International"].map(l => (
                <a 
                  key={l} 
                  href={l === "Drycom International" ? "/" : "#nosotros"} 
                  className="cf-footer-link"
                >
                  {l}
                </a>
              ))}
            </Col>
            <Col xs={12} lg={4}>
              <div className="cf-footer-heading">Contacto</div>
              <p className="cf-footer-link" style={{color: '#B8B8B8'}}>Guatemala City, Guatemala</p>
              <a href="tel:+50222011250" className="cf-footer-link">+502 2201-1250</a>
            </Col>
          </Row>
          <div className="cf-footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
            <p className="cf-footer-copy">© {currentYear} Construcciones Futuras · División de Drycom International · Todos los derechos reservados.</p>
            <p className="cf-footer-copy">Hecho en Guatemala 🇬🇹</p>
          </div>
        </Container>
      </footer>
    );
  }

  render() {
    return (
      <>
        {this.renderNavbar()}
        {this.renderHero()}
        {this.renderMarquee()}
        {this.renderCategories()}
        {this.renderWhyUs()}
        {this.renderBrands()}
        {this.renderCTABanner()}
        {this.renderContact()}
        {this.renderFooter()}
      </>
    );
  }
}

export default Construcciones;